var lib_core = require("lib-core");

var LibraryMetaData = require("./libraryMetaData.js");
var ComponentData = require("./../component/componentData.js");
var PackageData = require("./../package/packageData.js");
var SymbolData = require("./../symbol/symbolData.js");
var FootprintData = require("./../footprint/footprintData.js");

var LibraryData = function (init) {
    var self = this;

    this.makeObservableTreeNode();
    this.metaData = this.value("metaData", true);
    this.assets = this.list("assets", false);

    if(init) {
        var metaData = new LibraryMetaData();
        metaData.name("New Library");
        metaData.summary("");
        metaData.description("");
        this.metaData(metaData);
    }

    this.isComplete = this.shadow("isComplete",
        function() {
            // NOTE we should not be logging errors from within here.  This is a function to check if
            // the data is complete, an abstraction that should only checked, not error handling itself.
            // Handle errors after checking.  /Chris
            if(self.assets.size() === 0) {
                return false;
            }
            if(self.containsDuplicateAsset()) {
                return false;
            }

            return true;
        }, null,
        [this.assets]
    );


    this.assetIDList = this.shadow('fullAssetMap', function(){
        var assetIDList = {};
        this.addListAndAllChildren(assetIDList, this.assets);
        return assetIDList;
    }, null,
    [this.assets])
};

lib_core.mixin(LibraryData, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(LibraryData, "Library");

module.exports = LibraryData;

LibraryData.prototype.addListAndAllChildren = function(assetIDList, allAssets) {
    var self = this;
    allAssets.forEach(function(index, asset) {
        var id = "";
        if(asset.description){
            asset = asset.description();
        }

        var id = asset.root.getId()['id'];
        if(assetIDList[id] !== undefined) {
            //console.error('why you adding again?');
        } else {
            assetIDList[id] = {};
        }
        
        if(asset instanceof ComponentData){
            self.addListAndAllChildren(assetIDList, asset.packageInstances);
            self.addListAndAllChildren(assetIDList, asset.composedSymbol().symbolInstances);
            assetIDList[id] = "component";
        } else if(asset instanceof PackageData){
            self.addListAndAllChildren(assetIDList, asset.footprintInstances);
            assetIDList[id] = "package";
        } else if(asset instanceof FootprintData){
            assetIDList[id] = "footprint";
            return;
        } else if(asset instanceof SymbolData){
            assetIDList[id] = "symbol";
            return;
        } else {
            console.error('unknown asset type');
        }
    });
};

LibraryData.prototype.containsDuplicateAsset = function() {
    var assetsIds = [];
    
    for(var i = 0, l = this.assets.size(); i < l; i++) {
        var id = this.assets.get(i).root.getId()['id'];
        
        if(assetsIds.indexOf(id) > -1) {
            return true;
        }

        assetsIds.push(id);
    }

    return false;
};